/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GlobalRiskSettings {
  /**
   * Formula: \"1 = 0.1 BPS = 0.001% = 0.00001\". Moves mid price up or down for specified BPS.
   */
  shift: number;
  /**
   * Formula: \"1 = 0.1 BPS = 0.001% = 0.00001\". Extra move bid for specified BPS from mid px.
   */
  askChanger: number;
  /**
   * Formula: \"1 = 0.1 BPS = 0.001% = 0.00001\". Extra move bid for specified BPS from mid px.
   */
  bidChanger: number;
  /**
   * Multiplier for base spread setting.
   */
  askMultiplier: number;
  /**
   * Multiplier for base spread setting.
   */
  bidMultiplier: number;
}
